import React, { useEffect } from 'react';
import {
    Filter,
    DateField,
    TextField,
    ShowButton,
    FunctionField,
    SelectInput,
    TextInput,
    DateInput,
    SelectArrayInput,
    AutocompleteInput,
} from 'react-admin';
import moment from 'moment';
import CustomizableGrid from '../components/CustomizableGrid';
import { ColumnConfig } from '../hooks/useColumnReorder';
import BoxitPagination from '../components/BoxitPagination';
import ChipField from '../components/ChipField';

const CommunicationFilter = props => (
    <Filter variant="outlined" {...props}>
        {/*<CustomSearchInput alwaysOn />*/}
        <SelectArrayInput
            style={{ minWidth: '10rem' }}
            source="taskStatus"
            label="Task Status"
            choices={[
                {
                    id: 'new',
                    name: 'new',
                },
                {
                    id: 'running',
                    name: 'running',
                },
                {
                    id: 'complete',
                    name: 'complete',
                },
                {
                    id: 'failed',
                    name: 'failed',
                },
                {
                    id: 'paused',
                    name: 'paused',
                },
                {
                    id: 'cancelled',
                    name: 'cancelled',
                },
            ]}
        />
        <TextInput source="taskType" label="Task Type" />
        <TextInput label="Template Name" source="templateName" />
        <TextInput source="senderEmail" label="Sender Email" />
        <TextInput source="recipientEmail" label="Recipient Email" />
        <SelectInput
            source="channel"
            label="Channel"
            choices={[
                {
                    id: 'email',
                    name: 'Email',
                },
                {
                    id: 'whatsApp',
                    name: 'WhatsApp',
                },
            ]}
        />
        <SelectArrayInput
            style={{ minWidth: '10rem' }}
            source="deliveryStatus"
            label="Delivery Status"
            choices={[
                {
                    id: 'delivered',
                    name: 'delivered',
                },
                {
                    id: 'failed',
                    name: 'failed',
                },
                {
                    id: 'read',
                    name: 'read',
                },
                {
                    id: 'clicked',
                    name: 'clicked',
                },
                {
                    id: 'sent',
                    name: 'sent',
                },
                {
                    id: 'receivedReply',
                    name: 'receivedReply',
                },
            ]}
        />
        {/*<SelectInput
            source="status"
            label="Comm Status"
            choices={[
                {
                    id: 'sent',
                    name: 'sent',
                },
                {
                    id: 'rejected',
                    name: 'rejected',
                },
                {
                    id: 'pending',
                    name: 'pending',
                },
                {
                    id: 'initiated',
                    name: 'initiated',
                },
            ]}
        />*/}
        {/*<ReferenceInput
            source="senderId"
            reference="users"
            resource="users"
            label="sender"
        >
            <AutocompleteInput
                shouldRenderSuggestions={val => val.trim().length > 2}
                optionText={user => (user.name ? user.name : user.email)}
            />
        </ReferenceInput>*/}
        {/*<ReferenceInput
            source="recipientId"
            reference="users"
            resource="users"
            label="Recipient"
        >
            <AutocompleteInput
                shouldRenderSuggestions={val => val.trim().length > 2}
                optionText={user => (user.name ? user.name : user.email)}
            />
        </ReferenceInput>*/}
        {/*<TextInput source="senderPhone" label="Sender Phone" />
        <TextInput source="recipientPhone" label="Recipient Phone" />*/}
        {/*<TextInput source="taskId" label="Task Id" />*/}
        <DateInput
            source="sendDate[$gte]"
            label="Comm Sent Date From"
            style={{ width: '15rem' }}
            parse={v => v && moment(v).startOf('day').format()}
        />
        <DateInput
            source="sendDate[$lte]"
            label="Comm Sent Date To"
            style={{ width: '15rem' }}
            parse={v => v && moment(v).endOf('day').format()}
        />
        <DateInput
            source="deliveryDate[$gte]"
            label="Delivery Date From"
            style={{ width: '15rem' }}
            parse={v => v && moment(v).startOf('day').format()}
        />
        <DateInput
            source="deliveryDate[$lte]"
            label="Delivery Date To"
            style={{ width: '15rem' }}
            parse={v => v && moment(v).endOf('day').format()}
        />
        <DateInput
            source="openedDate[$gte]"
            label="Read (Opened) Date from"
            style={{ width: '15rem' }}
            parse={v => v && moment(v).startOf('day').format()}
        />
        <DateInput
            source="openedDate[$lte]"
            label="Read (Opened) Date To"
            style={{ width: '15rem' }}
            parse={v => v && moment(v).endOf('day').format()}
        />
        <DateInput
            source="clickedDate[$gte]"
            label="Clicked Date From"
            style={{ width: '15rem' }}
            parse={v => v && moment(v).startOf('day').format()}
        />
        <DateInput
            source="clickedDate[$lte]"
            label="Clicked Date To"
            style={{ width: '15rem' }}
            parse={v => v && moment(v).endOf('day').format()}
        />
    </Filter>
);

const defaultColumns: ColumnConfig[] = [
    { id: 'serial', label: 'Serial', visible: true, order: 0 },
    { id: 'id', label: 'Communication Id', visible: true, order: 1 },
    { id: 'taskStatus', label: 'Task Status', visible: true, order: 2 },
    { id: 'taskType', label: 'Task Type', visible: true, order: 3 },
    { id: 'templateName', label: 'Template Name', visible: true, order: 4 },
    { id: 'senderEmail', label: 'Sender Email', visible: true, order: 5 },
    { id: 'recipientEmail', label: 'Recipient Email', visible: true, order: 6 },
    { id: 'channel', label: 'Channel', visible: true, order: 7 },
    { id: 'deliveryStatus', label: 'Delivery Status', visible: true, order: 8 },
    { id: 'show', label: 'Show', visible: true, order: 9 },

    // Optional columns (visible: false by default)
    { id: 'createdAt', label: 'Created At', visible: false, order: 10 },
    { id: 'updatedAt', label: 'Updated At', visible: false, order: 11 },
    { id: 'sendDate', label: 'Send Date', visible: false, order: 12 },
    { id: 'deliveryDate', label: 'Delivery Date', visible: false, order: 13 },
    { id: 'openedDate', label: 'Opened Date', visible: false, order: 14 },
    { id: 'clickedDate', label: 'Clicked Date', visible: false, order: 15 },
    { id: 'senderPhone', label: 'Sender Phone', visible: false, order: 16 },
    {
        id: 'recipientPhone',
        label: 'Recipient Phone',
        visible: false,
        order: 17,
    },
    { id: 'taskId', label: 'Task ID', visible: false, order: 18 },
    { id: 'senderId', label: 'Sender ID', visible: false, order: 19 },
    { id: 'recipientId', label: 'Recipient ID', visible: false, order: 20 },
    { id: 'subject', label: 'Subject', visible: false, order: 21 },
    { id: 'content', label: 'Content', visible: false, order: 22 },
    { id: 'metadata', label: 'Metadata', visible: false, order: 23 },
    { id: 'errorMessage', label: 'Error Message', visible: false, order: 24 },
    { id: 'retryCount', label: 'Retry Count', visible: false, order: 25 },
    { id: 'priority', label: 'Priority', visible: false, order: 26 },
];

const renderColumn = (columnId: string) => {
    switch (columnId) {
        case 'serial':
            return (
                <TextField key={columnId} source="serial" sortable={false} />
            );
        case 'id':
            return (
                <TextField
                    key={columnId}
                    source="id"
                    label="Communication Id"
                />
            );
        case 'taskStatus':
            return (
                <ChipField
                    key={columnId}
                    source="taskStatus"
                    label="Task Status"
                    sortable={false}
                />
            );
        case 'taskType':
            return (
                <TextField
                    key={columnId}
                    source="taskType"
                    label="Task Type"
                    sortable={false}
                />
            );
        case 'templateName':
            return (
                <TextField
                    key={columnId}
                    source="templateName"
                    label="Template Name"
                />
            );
        case 'senderEmail':
            return (
                <TextField
                    key={columnId}
                    source="senderEmail"
                    label="Sender Email"
                />
            );
        case 'recipientEmail':
            return (
                <TextField
                    key={columnId}
                    source="recipientEmail"
                    label="Recipient Email"
                />
            );
        case 'channel':
            return (
                <ChipField key={columnId} source="channel" label="Channel" />
            );
        case 'deliveryStatus':
            return (
                <ChipField
                    key={columnId}
                    source="deliveryStatus"
                    label="Delivery Status"
                />
            );
        case 'show':
            return <ShowButton key={columnId} />;
        case 'createdAt':
            return (
                <DateField
                    key={columnId}
                    source="createdAt"
                    label="Created At"
                    locales="en-GB"
                />
            );
        case 'updatedAt':
            return (
                <DateField
                    key={columnId}
                    source="updatedAt"
                    label="Updated At"
                    locales="en-GB"
                    showTime
                />
            );
        case 'sendDate':
            return (
                <DateField
                    key={columnId}
                    source="sendDate"
                    label="Send Date"
                    locales="en-GB"
                    showTime
                />
            );
        case 'deliveryDate':
            return (
                <DateField
                    key={columnId}
                    source="deliveryDate"
                    label="Delivery Date"
                    locales="en-GB"
                    showTime
                />
            );
        case 'openedDate':
            return (
                <DateField
                    key={columnId}
                    source="openedDate"
                    label="Opened Date"
                    locales="en-GB"
                    showTime
                />
            );
        case 'clickedDate':
            return (
                <DateField
                    key={columnId}
                    source="clickedDate"
                    label="Clicked Date"
                    locales="en-GB"
                    showTime
                />
            );
        case 'senderPhone':
            return (
                <TextField
                    key={columnId}
                    source="senderPhone"
                    label="Sender Phone"
                />
            );
        case 'recipientPhone':
            return (
                <TextField
                    key={columnId}
                    source="recipientPhone"
                    label="Recipient Phone"
                />
            );
        case 'taskId':
            return <TextField key={columnId} source="taskId" label="Task ID" />;
        case 'senderId':
            return (
                <TextField key={columnId} source="senderId" label="Sender ID" />
            );
        case 'recipientId':
            return (
                <TextField
                    key={columnId}
                    source="recipientId"
                    label="Recipient ID"
                />
            );
        case 'subject':
            return (
                <TextField key={columnId} source="subject" label="Subject" />
            );
        case 'content':
            return (
                <FunctionField
                    key={columnId}
                    label="Content"
                    render={record => (
                        <div
                            style={{
                                maxWidth: '200px',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                            }}
                        >
                            {record.content}
                        </div>
                    )}
                />
            );
        case 'metadata':
            return (
                <FunctionField
                    key={columnId}
                    label="Metadata"
                    render={record => (
                        <div
                            style={{
                                maxWidth: '150px',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                            }}
                        >
                            {record.metadata
                                ? JSON.stringify(record.metadata)
                                : '-'}
                        </div>
                    )}
                />
            );
        case 'errorMessage':
            return (
                <FunctionField
                    key={columnId}
                    label="Error Message"
                    render={record => (
                        <div
                            style={{
                                maxWidth: '200px',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                                color: record.errorMessage ? 'red' : 'inherit',
                            }}
                        >
                            {record.errorMessage || '-'}
                        </div>
                    )}
                />
            );
        case 'retryCount':
            return (
                <TextField
                    key={columnId}
                    source="retryCount"
                    label="Retry Count"
                />
            );
        case 'priority':
            return (
                <ChipField key={columnId} source="priority" label="Priority" />
            );
        default:
            return null;
    }
};

const CommunicationList = props => {
    useEffect(() => {
        localStorage.removeItem('currentComMod');
    }, []);

    return (
        <CustomizableGrid
            title="Communication"
            bulkActionButtons={false}
            filters={<CommunicationFilter />}
            sort={{ field: 'id', order: 'DESC' }}
            defaultColumns={defaultColumns}
            renderColumn={renderColumn}
            pagination={<BoxitPagination />}
            {...props}
        />
    );
};

CommunicationList.defaultProps = {
    resource: 'Communication-records',
    location: { search: '' },
};

export default CommunicationList;
